import { FC } from 'react';
import { useSelector } from 'react-redux';
import LoadingPageSpinner from '../LoadingPageSpinner/LoadingPageSpinner';
import { RootState } from '@shared/types';

interface ComponentWithChunksProps<P> {
    featuresArray: (keyof RootState)[];
    hooksArray: Array<() => void>;
    Component: FC<P>;
}

const ComponentWithChunks = <P extends object>({
    featuresArray,
    hooksArray,
    Component,
    ...props
}: ComponentWithChunksProps<P> & P) => {
    const ready = useSelector((state: RootState) => featuresArray.every((feature) => Boolean(state[feature])));

    hooksArray.forEach((hook) => hook());

    if (!ready) {
        return <LoadingPageSpinner />;
    }

    return <Component {...(props as P)} />;
};

export default ComponentWithChunks;
